var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import i18next from 'i18next';
import defineLocale from '../defineLocale';
const useLocaleManager = () => {
    const [locale, setLocale] = useState(defineLocale());
    const [loaded, setLoaded] = useState(true);
    useEffect(() => {
        localStorage.setItem('locale', locale);
    }, []);
    const changeLocale = (language) => __awaiter(void 0, void 0, void 0, function* () {
        setLoaded(false);
        setLocale(language);
        localStorage.setItem('locale', locale);
        yield i18next.changeLanguage(language);
        setLoaded(true);
    });
    return {
        locale,
        changeLocale,
        loaded,
    };
};
export default useLocaleManager;
